
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/android/local/keyword-alerts",
      function () {
        return require("private-next-pages/android/local/keyword-alerts/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/android/local/keyword-alerts"])
      });
    }
  